var _style, _g, _path, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanzWhiteLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Balanz",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.61 71.39",
    style: {
      enableBackground: "new 0 0 188.61 71.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#151F6D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.46,4.07h14.72c5.96,0,9.99,1.93,9.99,7.75c0,3.07-1.53,5.21-4.25,6.53c3.81,1.1,5.73,4.03,5.73,7.93 c0,6.35-5.39,9.07-11.04,9.07H7.46V4.07z M14.34,16.73h6.96c2.41,0,4.2-1.1,4.2-3.72c0-2.98-2.28-3.59-4.73-3.59h-6.44V16.73z  M14.34,30h7.36c2.71,0,5.08-0.88,5.08-4.12c0-3.2-2.02-4.47-4.95-4.47h-7.49V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.84,4.07h7.05l11.7,31.28h-7.14l-2.36-6.97H44.39l-2.45,6.97h-6.97L46.84,4.07z M46.18,23.26h8.1 l-3.94-11.48h-0.08L46.18,23.26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.3,4.07 75.18,4.07 75.18,29.57 90.43,29.57 90.43,35.35 68.3,35.35  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.82,4.07h7.05l11.69,31.28h-7.14l-2.36-6.97h-11.7l-2.45,6.97h-6.97L102.82,4.07z M102.16,23.26h8.1 l-3.94-11.48h-0.09L102.16,23.26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.28,4.07 131.12,4.07 144.17,25.05 144.26,25.05 144.26,4.07 150.7,4.07 150.7,35.35  143.82,35.35 130.81,14.41 130.72,14.41 130.72,35.35 124.28,35.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.73,29.92 171.5,9.86 156.04,9.86 156.04,4.07 180.66,4.07 180.66,9.51 163.88,29.57  181.09,29.57 181.09,35.35 154.73,35.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.41,67.21H8.52v-7.68h4.28v0.79H9.41v2.81h3.18v0.79H9.41V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.02,59.53v4.97c0,0.88-0.27,1.56-0.79,2.06c-0.53,0.5-1.26,0.75-2.18,0.75c-0.92,0-1.64-0.25-2.15-0.76 c-0.51-0.5-0.76-1.2-0.76-2.08v-4.95h0.89v5.01c0,0.64,0.18,1.13,0.52,1.48c0.35,0.34,0.87,0.51,1.54,0.51 c0.65,0,1.15-0.17,1.5-0.52c0.35-0.35,0.52-0.84,0.52-1.48v-5H22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.21,67.21v-7.68h0.89v6.87h3.39v0.81H26.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.94,67.21v-7.68h0.89v6.87h3.39v0.81H33.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.63,67.21v-7.68h0.89v7.68H46.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.78,67.21h-1.02l-4.2-6.45h-0.04c0.06,0.76,0.08,1.45,0.08,2.08v4.37h-0.82v-7.68h1.01l4.19,6.42h0.04 c-0.01-0.09-0.02-0.4-0.05-0.91c-0.02-0.51-0.03-0.88-0.03-1.1v-4.41h0.84V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.43,59.53h0.96l-2.77,7.68h-0.88l-2.75-7.68h0.95l1.77,4.97c0.2,0.57,0.36,1.13,0.48,1.67 c0.13-0.57,0.29-1.13,0.49-1.7L66.43,59.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.88,67.21H70.6v-7.68h4.28v0.79h-3.39v2.47h3.18v0.79h-3.18v2.83h3.39V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.07,65.17c0,0.68-0.25,1.2-0.74,1.58c-0.49,0.38-1.16,0.57-2,0.57c-0.91,0-1.61-0.12-2.1-0.35V66.1 c0.31,0.13,0.66,0.24,1.03,0.32c0.37,0.08,0.74,0.12,1.1,0.12c0.6,0,1.04-0.11,1.34-0.34c0.3-0.23,0.45-0.54,0.45-0.94 c0-0.27-0.05-0.48-0.16-0.65c-0.11-0.17-0.29-0.33-0.54-0.47c-0.25-0.14-0.63-0.31-1.14-0.49c-0.71-0.26-1.23-0.56-1.53-0.91 c-0.31-0.35-0.46-0.81-0.46-1.37c0-0.59,0.22-1.06,0.67-1.41c0.44-0.35,1.03-0.53,1.76-0.53c0.76,0,1.47,0.14,2.11,0.42 l-0.28,0.78c-0.63-0.27-1.25-0.4-1.85-0.4c-0.47,0-0.84,0.1-1.11,0.3c-0.27,0.2-0.4,0.48-0.4,0.85c0,0.27,0.05,0.48,0.15,0.65 c0.1,0.17,0.26,0.33,0.5,0.47c0.23,0.14,0.59,0.3,1.07,0.47c0.81,0.29,1.36,0.6,1.66,0.92C82.91,64.21,83.07,64.64,83.07,65.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.15,67.21h-0.89v-6.89h-2.43v-0.79h5.76v0.79h-2.43V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.29,67.21l-2.61-6.81h-0.04c0.05,0.54,0.07,1.18,0.07,1.92v4.89h-0.82v-7.68h1.34l2.43,6.34h0.04 l2.45-6.34h1.33v7.68h-0.89v-4.95c0-0.57,0.02-1.18,0.07-1.85h-0.04l-2.63,6.8H98.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.04,67.21h-4.28v-7.68h4.28v0.79h-3.39v2.47h3.18v0.79h-3.18v2.83h3.39V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.89,67.21h-1.02l-4.2-6.45h-0.04c0.06,0.76,0.08,1.45,0.08,2.08v4.37h-0.82v-7.68h1.01l4.19,6.42h0.04 c-0.01-0.09-0.02-0.4-0.05-0.91c-0.02-0.51-0.03-0.88-0.03-1.1v-4.41h0.84V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.52,67.21h-0.89v-6.89h-2.43v-0.79h5.76v0.79h-2.43V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.04,67.21h-0.89V63.6h-4.05v3.61h-0.89v-7.68h0.89v3.27h4.05v-3.27h0.89V67.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.96,63.36c0,1.23-0.31,2.2-0.93,2.9c-0.62,0.7-1.49,1.06-2.59,1.06c-1.13,0-2-0.35-2.62-1.04 s-0.92-1.67-0.92-2.93c0-1.25,0.31-2.22,0.92-2.91s1.49-1.03,2.63-1.03c1.1,0,1.96,0.35,2.59,1.05 C154.65,61.16,154.96,62.13,154.96,63.36z M148.84,63.36c0,1.04,0.22,1.83,0.66,2.37c0.44,0.54,1.09,0.81,1.93,0.81 c0.85,0,1.49-0.27,1.93-0.8s0.65-1.33,0.65-2.37c0-1.03-0.22-1.82-0.65-2.35c-0.43-0.53-1.07-0.8-1.92-0.8 c-0.85,0-1.5,0.27-1.94,0.81C149.06,61.55,148.84,62.33,148.84,63.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.63,59.53v4.97c0,0.88-0.27,1.56-0.79,2.06c-0.53,0.5-1.26,0.75-2.18,0.75c-0.92,0-1.64-0.25-2.15-0.76 c-0.51-0.5-0.76-1.2-0.76-2.08v-4.95h0.89v5.01c0,0.64,0.18,1.13,0.52,1.48c0.35,0.34,0.87,0.51,1.54,0.51 c0.65,0,1.15-0.17,1.5-0.52c0.35-0.35,0.52-0.84,0.52-1.48v-5H164.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.14,65.17c0,0.68-0.25,1.2-0.74,1.58c-0.49,0.38-1.16,0.57-2,0.57c-0.91,0-1.61-0.12-2.1-0.35V66.1 c0.31,0.13,0.66,0.24,1.03,0.32c0.37,0.08,0.74,0.12,1.1,0.12c0.6,0,1.04-0.11,1.34-0.34c0.3-0.23,0.45-0.54,0.45-0.94 c0-0.27-0.05-0.48-0.16-0.65c-0.11-0.17-0.29-0.33-0.54-0.47c-0.25-0.14-0.63-0.31-1.14-0.49c-0.71-0.26-1.23-0.56-1.53-0.91 c-0.31-0.35-0.46-0.81-0.46-1.37c0-0.59,0.22-1.06,0.67-1.41c0.44-0.35,1.03-0.53,1.76-0.53c0.76,0,1.47,0.14,2.11,0.42 l-0.28,0.78c-0.63-0.27-1.25-0.4-1.85-0.4c-0.47,0-0.84,0.1-1.11,0.3c-0.27,0.2-0.4,0.48-0.4,0.85c0,0.27,0.05,0.48,0.15,0.65 c0.1,0.17,0.26,0.33,0.5,0.47c0.23,0.14,0.59,0.3,1.07,0.47c0.81,0.29,1.36,0.6,1.66,0.92C172.99,64.21,173.14,64.64,173.14,65.17 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.15,67.21h-4.28v-7.68h4.28v0.79h-3.39v2.47h3.18v0.79h-3.18v2.83h3.39V67.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.46,
    y: 48.61,
    className: "st0",
    width: 173.63,
    height: 0.73
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.96,5.25h10.11c4.09,0,6.86,1.33,6.86,5.33c0,2.11-1.05,3.58-2.92,4.48c2.62,0.75,3.94,2.77,3.94,5.45 c0,4.36-3.7,6.23-7.59,6.23h-10.41V5.25z M215.68,13.95h4.79c1.66,0,2.89-0.75,2.89-2.56c0-2.05-1.56-2.47-3.25-2.47h-4.42V13.95z  M215.68,23.07h5.06c1.87,0,3.49-0.6,3.49-2.83c0-2.2-1.39-3.07-3.4-3.07h-5.15V23.07z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "602.8,1050.01 602.8,1022.04 1684.88,1022.04 1684.88,1093.59 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.45,1655.33 -2.54,1655.33 -2.54,575.33 124.22,575.33 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanzWhiteLogo);
export default __webpack_public_path__ + "static/media/Balanz_white_logo.2bfd1b847f1bc38e1a80686be2600bf4.svg";
export { ForwardRef as ReactComponent };